import { Box, Button, GridItem, Text, Textarea, Tooltip } from '@chakra-ui/react';
import Details from './Details';
import DropdownNav from './DropdownNav';
import TimeBox from './TimeBox';
import { RiDeleteBin5Fill, RiFileDownloadLine } from 'react-icons/ri';
import { deleteResume, onLink } from '../../../handlers';
import { openPreview } from '../../../components/Preview/utils';
import { getUsefulVars } from '../../../handlers/helpers';
import React from 'react';

const SummaryBox = ({ props, formikProps, index, styles }) => {
  const uv = getUsefulVars(props,index);
  return (
    <GridItem colSpan={1}>
      <Box sx={{ ...styles.resumeSummary.mainwrapper }}>
        <Box sx={{ ...styles.resumeSummary.navBox }}>
          <Tooltip
            label="Delete"
            hasArrow
            bg="ORANGE"
            color="BLACK"
            fontWeight={600}
            borderRadius={99}
          >
          <Text
            label='delete'
            padding='.4rem .5rem 0 0'
                onClick={() => deleteResume(props, index)}>
            <RiDeleteBin5Fill
              size={25} color="Black" width='auto'/>
          </Text>
          </Tooltip>
          {uv.resume.industry !== undefined &&
            <Tooltip
              label="Download"
              hasArrow
              bg="ORANGE"
              color="BLACK"
              fontWeight={600}
              borderRadius={99}
            >
          <Text padding='.4rem .5rem 0 0'
                onClick={() => openPreview(props,index)}>

            <RiFileDownloadLine
              size={25} />
          </Text>
            </Tooltip>

          }
          <DropdownNav props={props} formikProps={formikProps} resumeIndex={index} />
        </Box>
        <Box flexDirection='column'>
        <Details styles={styles} uv={uv} props={props} />
        </Box>
        <Box sx={{ ...styles.resumeSummary.detailsDateBox }} >
          <TimeBox props={props} resumeIndex={index} />
        </Box>
      </Box>
    </GridItem>
  );
};

export default SummaryBox;
